const OSS = require('ali-oss');

// 初始化OSS客户端。请将以下参数替换为您自己的配置信息。
const client = new OSS({
    region: 'oss-cn-beijing', // 示例：'oss-cn-hangzhou'，填写Bucket所在地域。
    accessKeyId: 'LTAI5tEVmg5qEvyHPAVYHzFC', // 确保已设置环境变量OSS_ACCESS_KEY_ID。
    accessKeySecret: '0JzfkUquUNC33iiYoYS0AfuArHjwsy', // 确保已设置环境变量OSS_ACCESS_KEY_SECRET。
    bucket: 'miniapp-wujin', // 示例：'my-bucket-name'，填写存储空间名称。
});

export async function uploadFile(name, file, path = 'goods') {
    try {
        // 上传文件到OSS，'object'是OSS中的文件名，'localfile'是本地文件的路径。
        return await client.put('/dev/' + path + '/' + name, file);
    } catch (error) {
        console.error('发生错误:', error);
    }
}

export async function downloadFile(name) {
    try {
        const getResult = await client.get(name);
        console.log('获取文件成功:', getResult);
    } catch (error) {
        console.error('发生错误:', error);
    }
}
